import { translateLabel, useSettings } from "@repo/ui";

import { type CoWorkerScheduleActivity } from "../types";

export const ScheduleActivityTitle = ({
  item,
}: {
  item: CoWorkerScheduleActivity;
}) => {
  const { calendar, language } = useSettings();
  const activityConfig = calendar?.activity_configuration?.find(
    (t) => t.activity_key === item.activity
  );
  const translatedText = activityConfig?.translations?.find(
    (t) => t.language_key === language
  )?.translation;

  return <>{translatedText ?? translateLabel(item.title)}</>;
};
